// extracted by mini-css-extract-plugin
export default {"margin":"Layout_margin__KpCFz"};